import { engFlag, italyFlag } from "@components/images";

export const langOptions = [
  { country: "English", code: "en", flag: engFlag },
  { country: "Italiano", code: "it", flag: italyFlag },
];
